import {Component} from 'panel';

import {isFestiveMode} from 'common/util/festive-mode';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

export default registerMPElement(
  `mp-spinner`,
  class extends Component<{}> {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        'allow-festive': {
          type: `boolean`,
          description: `shows a festive mode spinner if is festive`,
        },
        color: {type: `string`, enum: [`white`, `blue`], default: `blue`},
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,
        helpers: {
          isFestiveMode: () => isFestiveMode() && this.attr(`allow-festive`),
        },
      };
    }
  },
);
